import { FeMap, FeMapPlugin } from '@fe/maplibre-extensions';
import { ExpressionSpecification } from 'maplibre-gl';
import { TerrainShadingSettings } from './navdata-types';

export class TerrainShadingLayer implements FeMapPlugin {
    private settings: TerrainShadingSettings | null = null;
    private map: FeMap | null = null;
    onAdd(map: FeMap) {
        this.map = map;
        if (this.settings) {
            this.update(this.settings);
        }
    }

    onRemove(map: FeMap) {
        this.map = null;
    }

    update(settings: TerrainShadingSettings) {
        this.settings = settings;
        if (!this.map) {
            return;
        }
        if (settings.enabled) {
            const altitudeMeters = settings.altitude * 0.3048;
            const color: ExpressionSpecification =
                settings.type === 'single'
                    ? ['interpolate', ['linear'], ['elevation'], altitudeMeters - 1, 'rgba(0,0,0,0)', altitudeMeters, settings.color]
                    : // prettier-ignore
                      [
                        'interpolate',
                        ['linear'],
                        ['elevation'],
                        399, 'rgba(0,0,0,0)',
                        400, 'rgb(4,0,108)',
                        583, 'rgb(5,1,154)',
                        766, 'rgb(10,21,189)',
                        949, 'rgb(16,44,218)',
                        1132, 'rgb(24,69,240)',
                        1315, 'rgb(20,112,193)',
                        1498, 'rgb(39,144,116)',
                        1681, 'rgb(57,169,29)',
                        1864, 'rgb(111,186,5)',
                        2047, 'rgb(160,201,4)',
                        2230, 'rgb(205,216,2)',
                        2413, 'rgb(244,221,4)',
                        2596, 'rgb(251,194,14)',
                        2779, 'rgb(252,163,21)',
                        2962, 'rgb(253,128,20)',
                        3145, 'rgb(254,85,14)',
                        3328, 'rgb(243,36,13)',
                        3511, 'rgb(215,5,13)',
                        3694, 'rgb(225,0,35)',
                        3877, 'rgb(230,0,55)',
                        4060, 'rgb(230,0,75)',
                        4243, 'rgb(225,0,95)',
                        4426, 'rgb(220,0,115)',
                        4609, 'rgb(210,0,130)',
                        4792, 'rgb(200,0,145)',
                        4975, 'rgb(190,0,160)',
                        5158, 'rgb(180,0,175)',
                        5341, 'rgb(170,0,190)',
                        5524, 'rgb(160,0,205)',
                        5707, 'rgb(150,0,215)',
                        5890, 'rgb(140,0,225)',
                        6073, 'rgb(130,0,235)',
                        6256, 'rgb(120,0,240)',
                        6439, 'rgb(110,0,245)',
                        6622, 'rgb(100,0,248)',
                        6805, 'rgb(90,0,250)',
                        6988, 'rgb(85,0,252)',
                        7171, 'rgb(80,0,254)',
                        7354, 'rgb(75,0,255)',
                        7537, 'rgb(70,0,255)',
                        7720, 'rgb(65,0,255)',
                        7900, 'rgb(60,0,255)'
                    ];

            const opacity = settings.type === 'single' ? 1.0 : settings.opacity / 100;

            if (!this.map.getLayer('fe-terrain-shade')) {
                this.map.addLayer(
                    {
                        id: 'fe-terrain-shade',
                        type: 'color-relief',
                        source: 'terrain_source',
                        paint: {
                            'resampling': 'linear',
                            'color-relief-opacity': opacity,
                            'color-relief-color': color
                        }
                    },
                    'fe-terrain-shade-slot'
                );
            } else {
                this.map.setPaintProperty('fe-terrain-shade', 'color-relief-opacity', opacity);
                this.map.setPaintProperty('fe-terrain-shade', 'color-relief-color', color);
            }
        } else {
            if (this.map.getLayer('fe-terrain-shade')) {
                this.map.removeLayer('fe-terrain-shade');
            }
        }
    }
}
